<template>
    <div id="cha">
        <div class="container">
            <div class="row">
              <div class="col-sm-4 hashtags">
                <form class="form-inline">
                <label v-for="i in chart_grams" v-bind:id="'tag_' + i" class="btn btn-link">
                  <input type="checkbox" autocomplete="off" v-bind:id="i" v-bind:value="i" v-model="kw_search" style="display: none;" v-on:click="toggle_active(i);">#{{stem_dict[i] || i}}
                  </input>
              </label></form>
            </div> <!-- col-sm-4 -->
             <div class="col-sm-8">
            <line-chart chart-id="chart" ref="chart_full" :chartData="chart_filter" :options="options"></line-chart>
        </div> <!-- col-sm-8 -->
        </div> <!-- row -->
    </div> <!-- container -->
</div> <!-- app -->
</template>

<script>
import LineChart from './LineChart.js';
import unigrams from '../assets/coefs_news.json';
import words from '../assets/words_news.json';
import months from '../assets/months.json';
import stem_dict from '../assets/stem_dict.json';
import kw_filter from '../mixins/kw_filter.js';
import chart_filter_m from '../mixins/chart_filter_m_stem.js';
import toggle_active from '../mixins/toggle_active.js';
import kw_search from '../mixins/kw_search.js';

function number_range (start, end) {
  return new Array(end - start).fill().map((d, i) => String(i + start));
}
function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}
function floats(n) {
  if (isNumeric(n)) {return parseFloat(n)} else {return 0};
}
function remove(array, element) {
    return array.filter(e => e !== element);
}

export default {
  name: 'cha',
  data () {
    return {
        unigrams: unigrams,
        chart_grams: words,
        kw_search: [],
        kw_old: [],
        dsets: [],
        cols: months,
        stem_dict: stem_dict,
        chart_filter: {'datasets': []},
        // '#2de100', '#e15a00', reserve complementary
        // colors: ['#222c40', '#888b95', '#1473e1', '#e1002d'],
        colors: ['#5c4c8e', '#3dbdbe', '#3c3950', '#c24a65'],
        months: number_range(0,25),
        options: {
          responsive: true,
          maintainAspectRatio: true,
          elements: { point: { radius: 0, hoverRadius: 0 } },
          tooltips: {
            enabled: false
          },

          scales: {
            
          xAxes: [
            {
              position: 'bottom',
              gridLines: {
                display: false,
              },
              ticks: {

            autoSkip: true,
                  display: true,
              }
            }]
          }
        },
    }
  },
  computed: {
  },
  components: {
    LineChart,
  },
  methods: {
  },
  watch: {kw_search: function(new_data){
        this.chart_filter = this.chart_filter_m(new_data);
        this.dsets = this.chart_filter['datasets'];
    },
  },
  mixins: [kw_filter, chart_filter_m, toggle_active, kw_search],
}
</script>


// WEBPACK FOOTER //
// src/components/Charts.vue